export interface Philosophy {
  title: string
  description: string
}

export const PHILOSOPHIES: Philosophy[] = [
  {
    title: 'Automation First',
    description:
      'Repetitive infrastructure and operational workflows should be automated, version-controlled and reproducible.',
  },
  {
    title: 'Secure by Default',
    description:
      'Identity, secrets, policies and workload security should be integrated into the platform — not bolted on after deployment.',
  },
  {
    title: 'Developer Self-Service',
    description:
      'Developers should be able to request infrastructure and environments without needing to become Kubernetes or cloud experts.',
  },
  {
    title: 'Everything as Code',
    description:
      'Infrastructure, configuration and delivery workflows should be version controlled, peer reviewed and reproducible across environments.',
  },
  {
    title: 'Observable by Design',
    description:
      'Systems should emit the telemetry required to understand and operate them, from the first commit to production.',
  },
]